import { define } from "../preactement/define";
import { attributes } from "./shared-attributes";
import { CheckIcon } from "../../Icons";
import { parseBooleanAttr } from "../wrapperUtils";

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const Wrapper = _ref => {
  let {
    ariaHidden = 'true',
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(CheckIcon, {
    ariaHidden: parseBooleanAttr(ariaHidden),
    ...otherProps
  });
};
define('ds-check-icon', () => Wrapper, {
  attributes
});